// extracted by mini-css-extract-plugin
export default {"input__buttons-group":"Buttons_input__buttons-group__4Du9k","btn":"Buttons_btn__VmFfC","btn-outline":"Buttons_btn-outline__sn8mF","btn-full":"Buttons_btn-full__MJpvs"};